import {
  CommunicationStatus,
  ResponseRejectionReason,
} from "@/briefpoint-client";
import type { DocumentSubType, FileExplorerVariant } from "@/lib/types";

export const API_URL: string = import.meta.env.VITE_API_URL;

export const CaliforniaId = "7c635e83-3d84-4b75-a09f-7acbe6c07bf8";

export const FederalId = "6652fce2-272b-4c70-b4a8-9b84642a465f";

export const SHARE_SITES = {
  GOOGLE: "Google",
  ICAL: "iCal",
  OUTLOOK: "Outlook",
};

export const ADD_POSITION = {
  END: "end",
  START: "start",
};

export const SEARCH_PARAMS = {
  LABEL: {
    TAB: "tab",
    SUB_TAB: "sub_tab",
    PRODUCE: "produce",
    WITHHELD: "withheld",
  },
  RESPONSE_TO_DISCOVERY: "respond_to_discovery",
  PROPOUND_DISCOVERY: "propound_discovery",
  UPLOAD_PRODUCTION: "upload_production",
  PRODUCTION: "production",
  WITHHELD_SEARCH: "withheld_search",
  SEARCH: "search",
  FILTER: "filter",
  INTERROGATORY_ID: "interrogatoryId",
  COLLECT_FROM_CLIENT: "collect_from_client",
};

export const FILE_EXPLORER_VARIANTS: Record<string, FileExplorerVariant> = {
  WIZARD: "wizard",
  CASE: "case",
};

export const PRODUCE_DOCUMENTS_OBJECTION_ID = 21;

export const UNABLE_TO_PRODUCE_OBJECTION_ID = 22;

/** labels as displayed to the user */
export const RESPONSE_REJECTION_REASON_LABELS: Record<
  ResponseRejectionReason,
  string
> = {
  [ResponseRejectionReason.NeverExisted]: "They never existed",
  [ResponseRejectionReason.Stolen]: "They were Stolen",
  [ResponseRejectionReason.NoLongerInPossession]: "I don't have them anymore",
  [ResponseRejectionReason.NeverInPossession]: "I never had them",
  [ResponseRejectionReason.Destroyed]: "They were destroyed",
  [ResponseRejectionReason.Lost]: "They were lost",
  [ResponseRejectionReason.Unknown]: "Other",
};

/** variant names as stored in the API (for objection variant lookup by name) */
export const RESPONSE_REJECTION_REASON_VARIANT_NAMES: Record<
  ResponseRejectionReason,
  string
> = {
  [ResponseRejectionReason.NeverExisted]: "Never existed",
  [ResponseRejectionReason.Stolen]: "Stolen",
  [ResponseRejectionReason.NoLongerInPossession]:
  "No longer in possession",
  [ResponseRejectionReason.NeverInPossession]: "Never in possession",
  [ResponseRejectionReason.Destroyed]: "Destroyed",
  [ResponseRejectionReason.Lost]: "Lost",
  [ResponseRejectionReason.Unknown]: "Unknown",
};

export const RESPONSIVE_FILE_ITEM_CHECKBOX = "responsive-file-item-checkbox";

export const DOCUMENT_SUB_TYPES: DocumentSubType[] = [
  {
    id: 1,
    name: "Interrogatories",
  },
  {
    id: 2,
    name: "Requests for Production",
  },
  {
    id: 3,
    name: "Requests for Admission",
  },
];

export const NO_CASE_TEXT = "All";

export const ACCEPTABLE_FILE_TYPES_WITH_IMAGES = [
  ".pdf",
  ".zip",
  ".gif",
  ".jpg",
  ".jpeg",
  ".png",
  "application/pdf",
  "application/zip",
];

export const SHOW_REMINDER_EMAIL_STATUSES = [
  CommunicationStatus.Sent,
  CommunicationStatus.InProgress,
  CommunicationStatus.Open,
];

export const HAS_SEEN_SIGN_UP_MODAL_STORAGE_KEY = "hasSeenSignUpModal";

export const COLLAPSED_ASSOCIATED_OBJECTS_TO_SHOW = 3;
